<ion-app name="root">
  <ion-header></ion-header>

  <ion-menu class="main-drawer"
            menuId="main-menu"
            contentId="main-content"
            side="start"
            type="overlay"
            (ionDidOpen)="onMainMenuOpen()"
            (ionDidClose)="onMainMenuClose()">
    <ion-content class="drawer-content">
      <div class="drawer-header">
        <div class="drawer-user"
             role="button"
             tabindex="0"
             (click)="navigateToSection('/profile')"
             (keyup.enter)="navigateToSection('/profile')"
             (keyup.space)="navigateToSection('/profile')">
          <user-avatar [fullName]="userFullName"
                       [avatarFile]="userAvatar"
                       avatarUrl="{{ (userFullName || userAvatar) ? '' : 'assets/icon/logo.png' }}">
          </user-avatar>
          <div class="drawer-user-info">
            <div class="drawer-name">
              {{ userFullName || 'Pyjam' }}
            </div>
            <div class="drawer-status" *ngIf="userStatusLine">{{ userStatusLine }}</div>
          </div>
        </div>
      </div>

      <ion-list
        class="drawer-list"
        lines="none"
        [class.drawer-list--with-downloads]="isMainMenuOpen && downloadManager.hasActiveDownloads()">
        <ng-container *ngFor="let group of drawerMenuGroups">
          <div class="drawer-group" [class.drawer-group--solo]="group.standalone">
            <ion-item class="drawer-item"
                      *ngFor="let item of group.items"
                      lines="none"
                      [button]="hasMenuRoute(item)"
                      [detail]="false"
                      [class.selected]="isMenuItemActive(item)"
                      [class.drawer-item--disabled]="!hasMenuRoute(item)"
                      (click)="onQuickMenuItemClick(item)">
              <ion-icon *ngIf="item.iconSrc" [src]="item.iconSrc" slot="start"></ion-icon>
              <ion-icon *ngIf="item.iconName" [name]="item.iconName" slot="start"></ion-icon>
              <ion-label>{{ item.labelKey | translate }}</ion-label>
              <span *ngIf="item.badgeType === 'messages' && (chatsService.hasUnreadMessages$ | async)" slot="end" class="drawer-dot"></span>
              <span *ngIf="item.badgeType === 'notifications' && notificationService.countNotifications()" slot="end" class="drawer-dot"></span>
            </ion-item>
          </div>
        </ng-container>
      </ion-list>

      <div
        class="drawer-downloads"
        slot="fixed"
        *ngIf="isMainMenuOpen && downloadManager.hasActiveDownloads()">
        <div class="drawer-downloads__header">
          <div class="drawer-downloads__title">
            {{ 'downloadsToast.downloading' | translate }}: {{ downloadManager.overallProgressPercent() }}%
          </div>
          <div class="drawer-downloads__counter">{{ downloadManager.activeTasksCount() }}</div>
        </div>
        <div class="drawer-downloads__list">
          <div
            class="drawer-downloads__item"
            *ngFor="let task of downloadManager.tasks(); trackBy: trackByDownloadTaskId">
            <div class="drawer-downloads__file-name" [title]="task.fileName">{{ task.fileName }}</div>
            <div class="drawer-downloads__progress">{{ task.progress }}%</div>
            <button
              type="button"
              class="drawer-downloads__cancel"
              *ngIf="task.cancelable"
              (click)="onCancelDownloadTask(task.id, $event)">
              {{ 'downloadsToast.cancel' | translate }}
            </button>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-menu>

  <ion-router-outlet
    id="main-content"
    [environmentInjector]="environmentInjector"
    [animated]="!disableChatTransition"
  ></ion-router-outlet>

  <ion-footer *ngIf="(showMenu$ | async)" class="ion-no-border" [class.footer-compact]="isFooterCompact()">
    <div class="footer-bg" aria-hidden="true"></div>
    <div class="footer-nav">
      <!--menu-->
      <div class="menu-item menu-item-left" [ngClass]="{selected: isMainMenuOpen}">
        <div role="button"
             tabindex="0"
             [attr.aria-label]="'app.menu.menu' | translate"
             (click)="openMainMenu()"
             (keyup.enter)="openMainMenu()"
             (keyup.space)="openMainMenu()">
          <div class="menu-icon-wrap">
            <ion-icon src="assets/app/icon/menu.svg" class="icon menu-icon"></ion-icon>
            <span class="menu-alert-indicator" *ngIf="(chatsService.hasUnreadMessages$ | async) || notificationService.countNotifications()"></span>
          </div>
        </div>
      </div>

      <!--go live-->
      <div class="menu-item main-action">
        <div class="main-action-inner">
          <ng-container [ngSwitch]="platformService.isSSR">
            <ng-container *ngSwitchCase="false">
              <div class="producer-action"
                   [routerLink]="['/avatar/producer']"
                   [attr.aria-label]="'avatar.producer.newStream' | translate">
                  <svg width="45" height="14" viewBox="0 0 45 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.3453 1.46556C14.326 1.27395 14.243 1.1251 14.0963 1.019C13.9497 0.912906 13.7506 0.859857 13.4992 0.859857C13.3284 0.859857 13.1842 0.88361 13.0665 0.931116C12.9489 0.977039 12.8586 1.04117 12.7958 1.12352C12.7345 1.20586 12.7039 1.29929 12.7039 1.4038C12.7007 1.49089 12.7192 1.5669 12.7595 1.63183C12.8014 1.69675 12.8586 1.75297 12.9311 1.80048C13.0037 1.8464 13.0875 1.88678 13.1825 1.92162C13.2776 1.95487 13.3792 1.98337 13.4871 2.00713L13.932 2.11164C14.1479 2.15914 14.3461 2.22249 14.5266 2.30166C14.7071 2.38084 14.8635 2.47823 14.9956 2.59382C15.1278 2.70942 15.2301 2.84561 15.3026 3.00238C15.3768 3.15914 15.4147 3.33888 15.4163 3.54157C15.4147 3.83927 15.3373 4.09739 15.1842 4.31591C15.0327 4.53286 14.8135 4.7015 14.5266 4.82185C14.2414 4.94062 13.8973 5 13.4944 5C13.0947 5 12.7466 4.93983 12.4501 4.81948C12.1551 4.69913 11.9247 4.52098 11.7587 4.28504C11.5943 4.04751 11.5081 3.75376 11.5 3.4038H12.5129C12.5242 3.5669 12.5717 3.70309 12.6555 3.81235C12.741 3.92003 12.8546 4.00158 12.9964 4.05701C13.1398 4.11085 13.3018 4.13777 13.4823 4.13777C13.6596 4.13777 13.8135 4.11243 13.944 4.06176C14.0762 4.01108 14.1785 3.94062 14.2511 3.85036C14.3236 3.76009 14.3598 3.65637 14.3598 3.53919C14.3598 3.42993 14.3268 3.33808 14.2607 3.26366C14.1963 3.18923 14.1012 3.12589 13.9755 3.07363C13.8514 3.02138 13.6991 2.97387 13.5186 2.93112L12.9795 2.7981C12.5621 2.69834 12.2325 2.54236 11.9907 2.33017C11.749 2.11797 11.6289 1.83215 11.6305 1.47268C11.6289 1.17815 11.7087 0.920823 11.8699 0.700713C12.0326 0.480602 12.2559 0.308789 12.5395 0.185273C12.8232 0.0617577 13.1455 0 13.5065 0C13.8739 0 14.1947 0.0617577 14.4686 0.185273C14.7442 0.308789 14.9586 0.480602 15.1117 0.700713C15.2648 0.920823 15.3437 1.17577 15.3486 1.46556H14.3453Z" fill="white"/>
                    <path d="M15.9318 0.914489V0.0665083H19.9979V0.914489H18.4822V4.93112H17.4475V0.914489H15.9318Z" fill="white"/>
                    <path d="M20.916 4.93112H19.7943L21.5034 0.0665083H22.8523L24.5591 4.93112H23.4374L22.1972 1.17815H22.1585L20.916 4.93112ZM20.8459 3.019H23.4954V3.82185H20.8459V3.019Z" fill="white"/>
                    <path d="M25.155 4.93112V0.0665083H27.1083C27.4822 0.0665083 27.8013 0.132225 28.0656 0.263658C28.3315 0.393508 28.5338 0.577989 28.6724 0.817102C28.8126 1.05463 28.8827 1.33413 28.8827 1.65558C28.8827 1.97862 28.8118 2.25653 28.6699 2.48931C28.5281 2.72051 28.3226 2.89786 28.0535 3.02138C27.786 3.14489 27.462 3.20665 27.0817 3.20665H25.7738V2.38005H26.9125C27.1123 2.38005 27.2783 2.35313 27.4104 2.29929C27.5426 2.24545 27.6409 2.16469 27.7054 2.05701C27.7715 1.94933 27.8045 1.81552 27.8045 1.65558C27.8045 1.49406 27.7715 1.35788 27.7054 1.24703C27.6409 1.13618 27.5418 1.05226 27.408 0.995249C27.2759 0.936659 27.1091 0.907364 26.9076 0.907364H26.2017V4.93112H25.155ZM27.8287 2.71734L29.0591 4.93112H27.9036L26.6997 2.71734H27.8287Z" fill="white"/>
                    <path d="M29.4338 0.914489V0.0665083H33.5V0.914489H31.9843V4.93112H30.9496V0.914489H29.4338Z" fill="white"/>
                    <path d="M6.92635 9.05178C6.89967 8.78353 6.78513 8.57514 6.58276 8.4266C6.38038 8.27807 6.10572 8.2038 5.75879 8.2038C5.52305 8.2038 5.32401 8.23705 5.16166 8.30356C4.99932 8.36785 4.87478 8.45764 4.78804 8.57292C4.70353 8.6882 4.66128 8.819 4.66128 8.96532C4.65683 9.08725 4.68241 9.19367 4.738 9.28456C4.79583 9.37546 4.87478 9.45416 4.97485 9.52067C5.07493 9.58496 5.19057 9.64149 5.32179 9.69026C5.453 9.73682 5.59311 9.77672 5.74211 9.80998L6.35592 9.95629C6.65392 10.0228 6.92747 10.1115 7.17655 10.2223C7.42563 10.3332 7.64135 10.4695 7.82371 10.6314C8.00607 10.7932 8.14729 10.9838 8.24737 11.2033C8.34967 11.4228 8.40193 11.6744 8.40416 11.9582C8.40193 12.375 8.29519 12.7363 8.08391 13.0423C7.87486 13.346 7.57241 13.5821 7.17655 13.7506C6.78291 13.9169 6.3081 14 5.75212 14C5.20058 14 4.72021 13.9158 4.31101 13.7473C3.90403 13.5788 3.58601 13.3294 3.35694 12.999C3.1301 12.6665 3.01112 12.2553 3 11.7653H4.39774C4.41331 11.9937 4.47892 12.1843 4.59456 12.3373C4.71243 12.488 4.86922 12.6022 5.06492 12.6798C5.26285 12.7552 5.48636 12.7929 5.73544 12.7929C5.98007 12.7929 6.19246 12.7574 6.37259 12.6865C6.55496 12.6155 6.69618 12.5169 6.79625 12.3905C6.89633 12.2641 6.94637 12.1189 6.94637 11.9549C6.94637 11.8019 6.90078 11.6733 6.8096 11.5691C6.72064 11.4649 6.58943 11.3762 6.41596 11.3031C6.24472 11.2299 6.03456 11.1634 5.78548 11.1036L5.04157 10.9173C4.46557 10.7777 4.01078 10.5593 3.67719 10.2622C3.3436 9.96516 3.17791 9.565 3.18014 9.06176C3.17791 8.64941 3.288 8.28915 3.51039 7.981C3.73501 7.67284 4.04302 7.4323 4.43444 7.25938C4.82585 7.08646 5.27064 7 5.7688 7C6.27585 7 6.71842 7.08646 7.09649 7.25938C7.47678 7.4323 7.77256 7.67284 7.98383 7.981C8.19511 8.28915 8.30408 8.64608 8.31075 9.05178H6.92635Z" fill="white"/>
                    <path d="M9.11554 8.28029V7.09311H14.7265V8.28029H12.6349V13.9036H11.2071V8.28029H9.11554Z" fill="white"/>
                    <path d="M15.6506 13.9036V7.09311H18.346C18.8619 7.09311 19.3023 7.18511 19.667 7.36912C20.0339 7.55091 20.313 7.80918 20.5043 8.14394C20.6978 8.47648 20.7945 8.86777 20.7945 9.31781C20.7945 9.77007 20.6967 10.1591 20.501 10.485C20.3053 10.8087 20.0217 11.057 19.6503 11.2299C19.2811 11.4029 18.8341 11.4893 18.3093 11.4893H16.5046V10.3321H18.0758C18.3515 10.3321 18.5806 10.2944 18.763 10.219C18.9453 10.1436 19.081 10.0306 19.1699 9.87981C19.2611 9.72906 19.3067 9.54173 19.3067 9.31781C19.3067 9.09169 19.2611 8.90103 19.1699 8.74584C19.081 8.59066 18.9442 8.47316 18.7596 8.39335C18.5773 8.31132 18.3471 8.27031 18.0691 8.27031H17.095V13.9036H15.6506ZM19.3401 10.8043L21.038 13.9036H19.4435L17.7822 10.8043H19.3401Z" fill="white"/>
                    <path d="M21.8153 13.9036V7.09311H26.4188V8.28029H23.2598V9.90309H26.182V11.0903H23.2598V12.7164H26.4322V13.9036H21.8153Z" fill="white"/>
                    <path d="M28.7448 13.9036H27.1969L29.5554 7.09311H31.4169L33.772 13.9036H32.2241L30.5128 8.64941H30.4595L28.7448 13.9036ZM28.6481 11.2266H32.3042V12.3506H28.6481V11.2266Z" fill="white"/>
                    <path d="M34.5943 7.09311H36.3757L38.2571 11.6689H38.3372L40.2186 7.09311H42V13.9036H40.5989V9.47078H40.5422L38.7742 13.8703H37.8201L36.0521 9.45416H35.9954V13.9036H34.5943V7.09311Z" fill="white"/>
                  </svg>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="true">
              <div class="producer-action">
                <a class="icon-inner" href="/avatar/producer" [attr.aria-label]="'avatar.producer.newStream' | translate">
                  <span class="main-action-text">{{ 'avatar.producer.newStream' | translate }}</span>
                </a>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!--streams-->
      <div class="menu-item menu-item-right"
           [ngClass]="{selected: router.isActive('/avatar', false) || requestedUrl === '/avatar'}">
        <ng-container [ngSwitch]="platformService.isSSR">
          <ng-container *ngSwitchCase="false">
            <div role="button"
                 tabindex="0"
                 [attr.aria-label]="'avatar.streamsModal.title' | translate"
                 (click)="navigateToSection('/avatar')"
                 (keyup.enter)="navigateToSection('/avatar')"
                 (keyup.space)="navigateToSection('/avatar')">
              <ion-icon src="assets/app/icon/world.svg" class="icon" (click)="openConsoleModal()"></ion-icon>
              <span class="executor-online-indicator" *ngIf="avatarService.isOnline"></span>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="true">
            <div class="icon" [ngClass]="{selected: router.isActive('/avatar', false) || requestedUrl === '/avatar'}">
              <a class="icon-inner" href="/avatar" [attr.aria-label]="'avatar.streamsModal.title' | translate">
                <!--assets/app/icon/world.svg-->
                <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.05 9H24.45M2.05 17H24.45M12.5833 1C10.3371 4.59948 9.14627 8.75715 9.14627 13C9.14627 17.2428 10.3371 21.4005 12.5833 25M13.9167 1C16.1629 4.59948 17.3537 8.75715 17.3537 13C17.3537 17.2428 16.1629 21.4005 13.9167 25M1.25 13C1.25 14.5759 1.56039 16.1363 2.16345 17.5922C2.7665 19.0481 3.65042 20.371 4.76472 21.4853C5.87902 22.5996 7.20189 23.4835 8.6578 24.0866C10.1137 24.6896 11.6741 25 13.25 25C14.8259 25 16.3863 24.6896 17.8422 24.0866C19.2981 23.4835 20.621 22.5996 21.7353 21.4853C22.8496 20.371 23.7335 19.0481 24.3366 17.5922C24.9396 16.1363 25.25 14.5759 25.25 13C25.25 9.8174 23.9857 6.76516 21.7353 4.51472C19.4848 2.26428 16.4326 1 13.25 1C10.0674 1 7.01516 2.26428 4.76472 4.51472C2.51428 6.76516 1.25 9.8174 1.25 13Z"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </a>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ion-footer>

  <download-app-prompt></download-app-prompt>
  <button
    class="downloads-fab"
    type="button"
    *ngIf="downloadManager.hasActiveDownloads()"
    [attr.aria-label]="'downloadsToast.downloading' | translate"
    (click)="onDownloadsFabClick()">
    <svg class="downloads-fab__ring" viewBox="0 0 52 52" aria-hidden="true">
      <circle
        class="downloads-fab__track"
        cx="26"
        cy="26"
        [attr.r]="downloadsProgressRingRadius">
      </circle>
      <circle
        class="downloads-fab__progress"
        cx="26"
        cy="26"
        [attr.r]="downloadsProgressRingRadius"
        [attr.stroke-dasharray]="downloadsProgressRingCircumference"
        [attr.stroke-dashoffset]="downloadsProgressDashOffset">
      </circle>
    </svg>
    <span class="downloads-fab__label">{{ downloadsProgressPercentLabel }}</span>
  </button>
  <button
    class="desktop-install-fab"
    type="button"
    *ngIf="canShowDesktopInstallButton"
    [attr.aria-label]="'desktopInstall.button' | translate"
    (click)="onDesktopInstallClick()">
    {{ 'desktopInstall.button' | translate }}
  </button>

  <offline-toast></offline-toast>
  <active-audio-call-widget></active-audio-call-widget>

  <div *ngIf="availableTips.length > 0 && currentHint !== null" class="hint-bg"></div>
  <div *ngIf="availableTips.length > 0 && currentHint !== null" class="hint hint--hidden">
    <div class="slider">
      <div class="tips-swiper">
        <div class="swiper-pagination tips-pagination"></div>
        <div class="swiper-wrapper">
          <div class="swiper-slide" *ngFor="let hint of availableTips; let i = index">
            <div class="close-btn" (click)="onCloseHintClick()">
              <img src="assets/icon/close.svg" alt="close">
            </div>
            <h5 class="header" [class.top-offset]="availableTips.length > 1">{{ 'tips.' + hint.name + '.header' | translate }}</h5>
            <div class="text">{{ 'tips.' + hint.name + '.text' | translate }}</div>
            <ion-button *ngIf="hint.ok" class="next-tip" color="dark" shape="round">
              {{ hint.ok }}
            </ion-button>
            <ion-button *ngIf="hint.ok && currentHint === availableTips.length - 1"
                        class="close-tip"
                        color="dark" shape="round"
                        (click)="onCloseHintClick()">
              {{ hint.ok }}
            </ion-button>
          </div>
        </div>
        <div class="swiper-button-next" [class.hidden]="availableTips[currentHint] && availableTips[currentHint].ok">
          <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.1786 11.9285L2.42861 20.6785C2.18204 20.9251 1.84762 21.0636 1.49892 21.0636C1.15022 21.0636 0.8158 20.9251 0.569232 20.6785C0.322664 20.432 0.184143 20.0976 0.184143 19.7489C0.184143 19.4002 0.322664 19.0657 0.569232 18.8192L8.39064 11L0.57142 3.17855C0.449332 3.05646 0.352485 2.91152 0.286412 2.752C0.220338 2.59249 0.18633 2.42152 0.18633 2.24886C0.18633 2.0762 0.220338 1.90523 0.286412 1.74572C0.352485 1.5862 0.449332 1.44126 0.57142 1.31917C0.693508 1.19708 0.838448 1.10024 0.997964 1.03416C1.15748 0.96809 1.32845 0.934082 1.50111 0.934082C1.67377 0.934082 1.84473 0.96809 2.00425 1.03416C2.16377 1.10024 2.30871 1.19708 2.43079 1.31917L11.1808 10.0692C11.303 10.1913 11.3999 10.3363 11.466 10.4959C11.532 10.6555 11.5659 10.8266 11.5657 10.9993C11.5655 11.1721 11.5312 11.3431 11.4648 11.5025C11.3984 11.662 11.3011 11.8068 11.1786 11.9285Z" fill="white"/>
          </svg>
        </div>
        <div class="swiper-button-prev" [class.hidden]="availableTips[currentHint] && availableTips[currentHint].ok">
          <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.4286 18.8214C11.6752 19.0679 11.8137 19.4024 11.8137 19.7511C11.8137 20.0998 11.6752 20.4342 11.4286 20.6807C11.182 20.9273 10.8476 21.0658 10.4989 21.0658C10.1502 21.0658 9.8158 20.9273 9.56923 20.6807L0.819231 11.9307C0.696871 11.8088 0.599786 11.6639 0.533541 11.5044C0.467297 11.3448 0.433197 11.1738 0.433197 11.0011C0.433197 10.8283 0.467297 10.6573 0.533541 10.4977C0.599786 10.3382 0.696871 10.1933 0.819231 10.0714L9.56923 1.32137C9.8158 1.0748 10.1502 0.936279 10.4989 0.936279C10.8476 0.936279 11.182 1.0748 11.4286 1.32137C11.6752 1.56794 11.8137 1.90236 11.8137 2.25106C11.8137 2.59976 11.6752 2.93417 11.4286 3.18074L3.60939 11L11.4286 18.8214Z" fill="white"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</ion-app>
